module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"caption-create":"Von {userName} {timestamp} erstellt"},"fr":{"caption-create":"Créé par {userName} {timestamp}"},"it":{"caption-create":"Creato da {userName} {timestamp}"}}')
  delete Component.options._Ctor
}
